import React from 'react'

import PerfectScrollBar from 'react-perfect-scrollbar'

import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core'

import * as service from 'service'
import useEmbeddedList from 'hooks/useEmbeddedList'
import helpers from 'helpers'
import styles from './styles'

import {
  TablePagination,
  TableRadioGroup,
  TableRadioGroupRow,
} from 'components/Table'
import useContract from 'hooks/useContract'

const useStyles = makeStyles(styles)

const TableClients = ({ name }) => {
  const classes = useStyles()
  const { data, setData } = useContract()

  const { response, pagination, isLoading } = useEmbeddedList(
    service.recurrence.customers.get,
    { customer: { name, active: true }, page: 1, perPage: 5 },
    [name],
  )

  const handleChangeCustomer = customer => {
    setData({ ...data, customer })
  }

  return (
    <div className={classes.root}>
      {isLoading ? (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      ) : (
        <Paper>
          <PerfectScrollBar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Nome/Fantasia</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {response.data.customers.length ? (
                  <TableRadioGroup
                    name="radioCustomer"
                    value={data.customer ? data.customer.id : null}
                    onChangeData={handleChangeCustomer}
                  >
                    {response.data.customers.map(customer => (
                      <TableRadioGroupRow
                        hover
                        name="radioCustomer"
                        value={customer.id}
                        data={customer}
                        key={customer.id}
                      >
                        <TableCell>{customer.email}</TableCell>
                        <TableCell>
                          {helpers.people.isCompany(customer.kind)
                            ? customer.tradeName
                            : customer.name}
                        </TableCell>
                      </TableRadioGroupRow>
                    ))}
                  </TableRadioGroup>
                ) : (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <div className={classes.boxClientNotFound}>
                        <Typography variant="overline">
                          Nenhum cliente foi encontrado
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </PerfectScrollBar>

          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={response.data.meta.totalCount}
              onChangePage={pagination.handleChangePage}
              onChangeRowsPerPage={pagination.handleChangeRowsPerPage}
              page={pagination.page}
              rowsPerPage={pagination.perPage}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </Paper>
      )}
    </div>
  )
}

export default TableClients
